import lodash from 'lodash'

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate (data, id = 'id', pid = 'parentId') {
  var res = []
  var temp = {}
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i]
  }
  for (var k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]]['children']) {
        temp[data[k][pid]]['children'] = []
      }
      if (!temp[data[k][pid]]['_level']) {
        temp[data[k][pid]]['_level'] = 1
      }
      data[k]['_level'] = temp[data[k][pid]]._level + 1
      data[k]['_parent'] = data[k][pid]
      temp[data[k][pid]]['children'].push(data[k])
    } else {
      res.push(data[k])
    }
  }

  return res
}

export const TreeConfig = function(props) {
    let _config = { ...TreeConfig.build(), ...props }

    return _config;
}

TreeConfig.build = function() {
    return {
        id: 'id',
        parentId: 'parentId',
        children: '_children',
        parent: 'parent',
        level: 'level',
        expanded: 'isExpanded',
        leafCallback: undefined,
        defaultExpandAll: false,
        accordion: false
    };
}

export const TreeNode = function(data, config) {
    this._config = config;

    this._rawData = lodash.clone(data);
    let _children = [];
    let _level = 0;
    let _expanded = false;
    let _parent = undefined;

    for (let key in this._rawData) {
        Object.defineProperty(this, key, {
            get: function() {
                return this._rawData[key];
            },
            set: function(newValue) {
                this._rawData[key] = newValue;
            }
        });
    }

    // 设置树节点的level属性
    if (!this.hasOwnProperty(config.level)) {
        Object.defineProperty(this, config.level, {
            get: function() {
                return _level;
            },
            set: function(newValue) {
                if (_level === newValue) {
                    return;
                }
                else {
                    _level = newValue;
                    _children.forEach(child => {
                        child[config.level] = newValue + 1;
                    });
                }
            }
        });
    }
    else {
        console.warn(`[tree] property ${config.level} exist, pleace check!`);
    }
    
    // 节点是否展开
    if (!this.hasOwnProperty(config.expanded)) {
        Object.defineProperty(this, config.expanded, {
            get: function() {
                return _expanded;
            },
            set: function(newValue) {
                _expanded = newValue;
            }
        });
    }
    else {
        console.warn(`[tree] property ${config.expanded} exist, pleace check!`);
    }

    //获取子节点
    if (!this.hasOwnProperty(config.children)) {
        Object.defineProperty(this, config.children, {
            get : function() {
                return _children;
            },
            set: function(newValue) {
                if (Array.isArray(newValue)) {
                    this.removeAllChildren();

                    newValue.forEach((item) => {
                        if (item instanceof TreeNode) {
                            _children.push(item);
                            item[config.level] = _level + 1;
                            item[config.parent] = this;
                        }
                        else {
                            let temp = new TreeNode(item, config);
                            _children.push(temp);
                            temp[config.level] = _level + 1;
                            temp[config.parent] = this;
                        }
                    });
                }
                else {
                    console.error(`[tree] children must be an array, pleace check!`);
                }
            }
        });
    }
    else {
        console.warn(`[tree] property ${config.children} exist, pleace check!`);
    }

    //获取父节点
    if (!this.hasOwnProperty(config.parent)) {
        Object.defineProperty(this, config.parent, {
            get: function() {
                return _parent;
            },
            set: function(newValue) {
                if (_parent !== newValue) {
                    if (newValue instanceof TreeNode) {
                        if (_parent != null) {
                            _parent.removeChild(this);
                        }
                        
                        _parent = newValue;
                        if (_parent != null) {
                            _parent[config.children].push(this);
                        }
                    }
                }
            }
        });
    }
    else {
        console.warn(`[tree] property ${config.parent} exist, pleace check!`);
    }
}

/**
 * 判断指定id的节点是否存在
 * @param id 要查找的id
 * @param includeChild 是否递归查找子节点
 * @return 找到的节点
 */
TreeNode.prototype.hasChild = function(id, includeChild = false) {
    let config = this._config;
    for (let i = 0; i < this[config.children].length; i++) {
        if (this[config.children][i][config.id] === id) {
            return this[config.children][i];
        }
        else {
            if (includeChild) {
                let temp = this[config.children][i].hasChild(id, includeChild);
                if (temp != null) return temp;
            }
        }
    }

    return null;
}
/**
 * 添加子节点
 */
TreeNode.prototype.addChild = function(child) {
    let config = this._config;
    if (child instanceof TreeNode) {
        child[config.parent] = this;
        child[config.level] = this[config.level] + 1;
    }
    else {
        let temp = new TreeNode(child, config);
        temp[config.parent] = this;
        temp[config.level] = this[config.level] + 1;
    }
}
/**
 * 移除子节点
 * @param id 要移除节点的id
 * @param includeChild 是否从子节点中查找并移除
 */
TreeNode.prototype.removeChild = function(id, includeChild = true) {
    let config = this._config;
    for (let i = 0; i < this[config.children].length; i++) {
        if (this[config.children][i][config.id] === id) {
            this[config.children][i] = null;
            this[config.children].splice(i, 1);
            return true;
        }
        else {
            if (includeChild) {
                if (this[config.children][i].removeChild(id, includeChild)) {
                    return true;
                }
            }
        }
    }

    return false;
}
/**
 * 移除所有子
 */
TreeNode.prototype.removeAllChildren = function() {
    let config = this._config;
    for (let i = 0; i < this[config.children].length; i++) {
        this[config.children][i].removeAllChildren();
        this[config.children][i] = null;
    }
    this[config.children] = [];
}
/**
 * 获得所有子节点数量
 * @param includeChild 是否统计间接子节点
 */
TreeNode.prototype.getChildCount = function(includeChild = false) {
    if (includeChild) {
        let count = this[config.children].length;
        this[config.children].forEach(child => {
            count += child.getChildCount(includeChild);
        });

        return count;
    }
    else {
        return this[config.children].length;
    }
}

export const Tree = function(data, props) {
    let _config = new TreeConfig(props == null ? {} : props);

    // 树上所有节点的map<string, TreeNode>
    let _treeNodeMap = null;
    // 根节点List<TreeNode>
    let _rootList = null;
    // 根据节点展开状态输出的行列表List<TreeNode>
    let _expandRowList = null;
    // 展开的节点的id列表List<string>
    let _expandKeys = null;

    function $init() {
        _treeNodeMap = new Map();
        _rootList = new Array();
        _expandRowList = new Array();
        _expandKeys = new Set();
    }

    function $clear() {
        _treeNodeMap = null;
        _rootList = null;
        _expandRowList = null;
        _expandKeys = null;
    }

    function $reset(rawData, isInit = false) {
        let oldExpandKeySet = new Set(Array.from(_expandKeys));
        if (!isInit) { //不是第一次则清空现有数据
            $clear();
            $init();
        }

        if (Array.isArray(rawData)) {
            rawData.forEach((item) => {
                let treeNode = new TreeNode(item, _config);

                if (_config.defaultExpandAll && isInit) {  // 第一次加载按照配置设置展开状态
                    treeNode[_config.expanded] = true;
                    _expandKeys.add(treeNode[_config.id]);
                }
                else {
                    // 根据老的展开列表，恢复展开状态
                    if (oldExpandKeySet.has(treeNode[_config.id])) {
                        treeNode[_config.expanded] = true;
                        _expandKeys.add(treeNode[_config.id]);
                    }
                }
                _treeNodeMap[treeNode[_config.id]] = treeNode;
            });
    
            rawData.forEach((item) => {
                let node = _treeNodeMap[item[_config.id]];
                let parentNode = _treeNodeMap[item[_config.parentId]];
                if (parentNode != null) {
                    parentNode.addChild(node);
                }
                else {
                    _rootList.push(node);
                }
            });
        }

        oldExpandKeySet = null;
    }

    function $getExpandRows(root) {
        if (root instanceof TreeNode) {
            _expandRowList.push(root);
            if (root[_config.expanded]) {
                root[_config.children].forEach((item) => {
                    $getExpandRows(item);
                });   
            }
        }
        else {
            console.warn('[tree] invalid node type!');
        }
    }

    function $refresh() {
        _expandRowList = [];
        _rootList.forEach((root) => {
            $getExpandRows(root);
        });

        return _expandRowList;
    }

    function $setExpandStatus(expandKeys) {
        let expandKeySet = new Set(expandKeys);

        // 清除之前的打开状态
        for (let key of _expandKeys) {
            let node = _treeNodeMap[key];
            if (node != null) {
                node[_config.expanded] = false;
            }
        }

        _expandKeys = new Set();
        for (let key in _treeNodeMap) {
            let node = _treeNodeMap[key];
            node[_config.expanded] = expandKeySet.has(node[_config.id]);
            if (node[_config.expanded]) _expandKeys.add(node[_config.id]);
        }
    }

    function $toggleExpand(id) {
        let currentExpandStatus = _expandKeys.has(id);
        if (_config.accordion && !currentExpandStatus) { //手风琴模式展开
            let node = _treeNodeMap[id];
            if (node == null) return;

            let parentNode = _treeNodeMap[node[_config.parentId]];

            //关闭父节点上所有展开的节点
            if (parentNode == null) {   //根节点
                //关闭所有展开节点
                _rootList.forEach((root) => {
                    if (root[_config.expanded]) {
                        root[_config.expanded] = false;
                        _expandKeys.delete(root[_config.id]);
                    }
                });
            }
            else {  
                parentNode[_config.children].forEach((child) => {
                    if (child[_config.expanded]) {
                        child[_config.expanded] = false;
                        _expandKeys.delete(child[_config.id]);
                    }
                });
            }

            node[_config.expanded] = true;
            _expandKeys.add(id);
        }
        else {
            if (currentExpandStatus) {
                _treeNodeMap[id][_config.expanded] = false;
                _expandKeys.delete(id);
            }
            else {
                _treeNodeMap[id][_config.expanded] = true;
                _expandKeys.add(id);
            }
        }

        return $refresh();
    }

    $init();
    $reset(data, true);
    //$refresh();
    
    return {
        /**
         * 切换指定node的展开收起状态
         * @param {*} id 
         */
        toggleExpand: function(id) {
            return $toggleExpand(id);
        },
        /**
         * 刷新数据，根据展开状态重新计算rowlist
         */
        refresh: function() {
            return $refresh();
        },
        /**
         * 重置设置数据，但是保留展开收起状态，用于重新刷新当前数据
         * @param {*} data 
         */
        reset: function(data) {
            $reset(data);
            return $refresh();
        },
        /**
         * 获取树所有根节点数据列表
         */
        getRoot: function() {
            return _rootList;
        },
        /**
         * 设置展开节点
         * @param {*} expandKeys 展开节点id的数组
         */
        setExpandKeys: function(expandKeys) {
            $setExpandStatus(expandKeys);
        }
    }
}

/**
 * 
 */
export function translateTreeData(data, props) {
    return new Tree(data, props);
}

/**
 * 获取字符串字节长度
 * @param {*} s
 */
export function getStringLength (s) {
  return s.replace(/[\u4e00-\u9fa5\uff00-\uffff]/g, '**').length
}

/**
 * 获取uuid
 */
export function getUUID () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
  })
}

/**
 * 
 * @param {*} name 要转换的字符串
 * @param {*} type 转换的类型0：转换成小驼峰，1：转换成大驼峰
 */
export function nameTranslate(name, type) {
    name = name.toLowerCase();
    let nameArray = name.split('_');
    nameArray.forEach((item, index) => {
        if (index === 0) {
            name = type === 1 ? item.slice(0, 1).toUpperCase() + item.slice(1) : item;
        }
        else {
            name = name + item.slice(0, 1).toUpperCase() + item.slice(1);
        }
    });

    nameArray = name.split('-');
    nameArray.forEach((item, index) => {
        if (index === 0) {
            name = type === 1 ? item.slice(0, 1).toUpperCase() + item.slice(1) : item;
        }
        else {
            name = name + item.slice(0, 1).toUpperCase() + item.slice(1);
        }
    });
    return name;
}

export function isInteger(value) {
    let reg = /^\d+$/;
    return reg.test(value);
}

export function isBoolean(value) {
    return (value === 'true') || (value === 'false');
}

/**
 * 返回从根节点到指定节点的路径
 */
export function findTreeNodePath(treeRoot, id, idKey = 'id', childKey = 'children') {
    function findNode(list, node, id) {
        list.push(node[idKey]);
        if (node[idKey] === id) {
            return true;
        }

        if (node[childKey] != null && Array.isArray(node[childKey])) {
            for (let i = 0; i < node[childKey].length; i++) {
                if (findNode(list, node[childKey][i], id)) {
                    return true;
                }
            }
        }

        list.pop();
        return false;
    }

    let tempList = [];
    for (let i = 0; i < treeRoot.length; i++) {
        if (findNode(tempList, treeRoot[i], id)) {
            return tempList;
        }
    }

    return [];
}

export function objectToQueryString (params) {
    if (params == null) {
        return null;
    } else {
        return Object.keys(params).map((key) => {
            return `${key}=${params[key]}`;
        }).join('&');
    }
}


// WEBPACK FOOTER //
// ./src/utils/index.js